<template>
  <div>
    <!-- box comments -->
    <div v-if="comment_requests.length != 0">
      <div class="flex flex-col pb-4">
        <div class="flex flex-col shadow-md bg-gray-100 mb-1 pt-0 p-3">
          <div class="p-2">
            <div class="flex justify-between">
              <h2
                class="text-red text-lg text-bold capitalize mt-2 pb-4 pt-2 border-red-light ml-0"
              >{{ $t("requests.remarques")}}</h2>
              <div class="flex items-center w-auto bg-white pb-4 mr-0 mt-3">
                <sp-button
                  theme="outline-blue"
                  space="small"
                  type="submit"
                  class="justify-end rounded mx-0 add-comment-btn"
                  @click="showModal()"
                >
                  <i class="fas fa-comment-dots"></i>
                  {{ $t("form.write_comment")}}
                </sp-button>
              </div>
            </div>
            <!-- <div class="flex-wrap rounded-full justify-center border-grey-light my-3" v-for="(comment_request,index) in comment_requests"
              :key="index" :class="{ 'comment-candidat': comment_request.user_id === candidat.id, 'comment-responsible': comment_request.user_id !== candidat.id }"
            >
              <div class="flex">
                <h4>{{comment_request.last_name}} {{comment_request.name }} &nbsp;</h4>
                <p>{{ $t("form.added_comment")}} &nbsp;</p>
                <h5 class="mt-1">{{new Date(comment_request.created_at)| dateFormat('DD/MM/YYYY')}}</h5>
              </div>
              <span v-html="comment_request.content"></span>
            </div>-->

            <div v-for="(comment_request,index) in comment_requests" :key="index">
              <ul class="comments-timeline">
                <li>
                  <time class="comment-time">
                    <span>{{new Date(comment_request.created_at)| dateFormat('DD/MM/YYYY HH:mm')}}</span>
                  </time>
                  <div class="comment-icon">
                    <div v-if="comment_request.user_id === candidat.id">
                      <i class="icon-message icon-message-candidat fas fa-comment-dots"></i>
                      <!-- <img class="img-message" src="../../assets/img/icon_candidat.svg" alt="icon message candidat" /> -->
                    </div>
                    <div v-else>
                      <i class="icon-message icon-message-responsible fas fa-comment-dots"></i>
                      <!-- <img class="img-message"  src="../../assets/img/icon_admin.svg" alt="icon message admin"/> -->
                    </div>
                  </div>
                  <div class="flex-wrap comment-content">
                    <div class="flex">
                      <h4 v-if="comment_request.user_id === candidat.id">{{comment_request.last_name}} {{comment_request.name }} &nbsp;</h4>
                      <h4 v-else>{{ $t("team.team_startupact")}} &nbsp;</h4>
                      <p>{{ $t("form.added_comment")}} &nbsp;</p>
                    </div>
                    <blockquote>
                      <p class="blockquote blockquote-primary" v-html="comment_request.content"></p>
                    </blockquote>
                    <div v-if="comment_request.document_id">
                      <a :href="comment_request.path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    <div v-else>
                      <div v-if="comment_request.document_path">
                      <a :href="comment_request.document_path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end box comments -->

    <h1
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
    >{{ $t('requests.detail_request') }}</h1>

    <div
      v-if="comment_requests.length == 0"
      class="flex items-center justify-end w-auto bg-white mx-0"
    >
      <sp-button
        theme="outline-blue"
        space="small"
        type="submit"
        class="justify-end rounded add-comment-btn"
        @click="showModal()"
      >
        <i class="fas fa-comment-dots"></i>
        {{ $t("form.write_comment")}}
      </sp-button>
    </div>

    <!-- Modal add comment request -->
    <commentRequest @add-comment="onClickCommentRequest" />

    <div v-if="details">
      <div class="flex flex-col mt-8">
        <div class="flex flex-col shadow-md bg-gray-100 mb-3 p-3">
          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t("requests.name_project") }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <span v-if="details.project && details.project.project_name">{{details.project.project_name}}</span>
            </div>
          </div>

          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t("requests.advantage_type") }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <span v-if="details.type">{{details.type}}</span>
            </div>
          </div>
          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t("requests.status") }} :</div>
            <div class="flex-1 px-4 py-2 m-2 font-semibold text-red">
              <span v-if="details.advRequest.status == 0">{{$t("requests.new_request")}}</span>
              <span v-if="details.advRequest.status == 1">{{$t("requests.pending_request")}}</span>
              <span v-if="details.advRequest.status == 2">{{$t("requests.accepted_request")}}</span>
              <span v-if="details.advRequest.status == 3">{{$t("requests.refused_request")}}</span>
              <span v-if="details.advRequest.status == 4">{{$t("requests.invalid_request")}}</span>
              <span v-if="details.advRequest.status == 5">{{$t("requests.aneti_request")}}</span>
              <span v-if="details.advRequest.status == 6">{{$t("requests.douane_request")}}</span>
              <span v-if="details.advRequest.status == 7">{{$t("requests.waiting_response_from_employer")}}</span>
              <span v-if="details.advRequest.status == 10">{{$t("requests.removed_bourse")}}</span>
              <span v-if="details.advRequest.status == 11">{{$t("requests.leave_removed")}}</span>
              <span v-if="details.advRequest.status == 12">{{$t("requests.leave_extended")}}</span>
              <span v-if="details.advRequest.status == 13">{{$t("requests.innorpi_request")}}</span>
            </div>
          </div>
          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.submitted') }} :</div>
            <div
              class="flex-1 px-4 py-2 m-2"
            >{{new Date(details.advRequest.created_at.date ? details.advRequest.created_at.date: details.advRequest.created_at)| dateFormat('DD/MM/YYYY')}}</div>
          </div>
          <div class="inline-flex" v-if="details.advRequest.bourse_value">
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.bourse_value') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">{{details.advRequest.bourse_value}}</div>
          </div>
          <div
            class="inline-flex"
            v-if="details.type == $t('requests.request_bourse') && details.advRequest.decision_aneti_bourse"
          >
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.decision_bourse') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a
                :href="details.advRequest.decision_aneti_bourse"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_bourse') }}</a>
            </div>
          </div>
          <div
            class="inline-flex"
            v-if="((details.type == $t('requests.request_bourse') && details.advRequest.decision_stop_bourse)|| (details.type == $t('requests.request_stop_bourse') && details.advRequest.decision_aneti_bourse))"
          >
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.decision_stop_bourse') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a
                :href="details.advRequest.decision_stop_bourse ? details.advRequest.decision_stop_bourse : details.advRequest.decision_aneti_bourse"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_stop_bourse') }}</a>
            </div>
          </div>
          <div
            class="inline-flex"
            v-if="(details.type == $t('requests.request_stop_leave') && details.advRequest.decision_stop_leave) &&  !['0', '1'].includes(details.advRequest.status)"
          >
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.decision_stop_leave') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a
                :href="details.advRequest.decision_stop_leave"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_stop_leave') }}</a>
            </div>
          </div>
          <div
            class="inline-flex"
            v-if="details.type == $t('requests.request_cnss') && details.advRequest.decision_aneti_cnss"
          >
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.decision_cnss') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a v-if="(details.type == $t('requests.request_cnss') && details.advRequest.decision_aneti_cnss) "
                :href="details.advRequest.decision_aneti_cnss"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_cnss')}}</a>
              <a v-if="details.type == $t('requests.request_stop_bourse') && details.advRequest.decision_aneti_bourse"
                :href="details.advRequest.decision_aneti_bourse"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_stop_bourse') }}</a>
            </div>
          </div>
          <div
            class="inline-flex"
            v-if="(details.type == $t('requests.request_leave') && details.advRequest.decision_stop_leave) && !['0', '1'].includes(details.advRequest.status)"
          >
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.decision_stop_request_leave') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a
                :href="details.advRequest.decision_stop_leave"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_stop_request_leave') }}</a>
            </div>
          </div>
        </div>
        <br />
        <div class="inline-flex">
          <div
            class="flex-1 text-lg mb-1 border-red-light font-semibold text-red"
          >{{ $t("requests.detail_question") }}</div>
        </div>
        <form autocomplete="off" name="formrequest" v-on:submit.prevent="requestFormGetDetail()">
          <div v-for="cat in requestForm.categories" :key="cat.sort_order">
            <div v-for="(q, index) in responses_questions" :key="index">
              <div v-if="q.category_id === cat.id">
                <q-form
                  :question="q"
                  :started="true"
                  @update-disabled="updateDisabled"
                  :showError="showError"
                  :requestFormShow="true"
                  :responses="responses"
                  :disabled="true"
                  :labelDate="getLabelCreatedAt"
                ></q-form>
              </div>
            </div>
          </div>
        </form>
      </div>

        <div
            v-if="details && details.advRequest && ('closed_request' in details.advRequest)"
            class="flex-1 text-lg mb-3 border-red-light font-semibold text-red mt-3"
          >{{ details.advRequest.status == '11' ? $t('requests.decision_stop_request_leave') : $t('requests.removed_request_decision')}}</div>
        </div>
       <div v-if="details && details.advRequest && ('closed_request' in details.advRequest)" class="flex flex-col shadow-md bg-gray-100 mb-3 p-3">
          <div class="inline-flex" v-if="details.advRequest.closed_request.stop_date">
            <div class="flex-1 px-4 py-2 m-2">{{details.advRequest.status == '11' ? $t('requests.date_stop_leave') : $t('requests.date_stop_request')}} :</div>
            <div
              class="flex-1 px-4 py-2 m-2"
            >{{new Date(details.advRequest.closed_request.stop_date)| dateFormat('DD/MM/YYYY')}}</div>
          </div>

          <div class="inline-flex" v-if="details.advRequest.closed_request.motif">
            <div class="flex-1 px-4 py-2 m-2">{{ details.advRequest.status == '11' ? $t('requests.motif_stop_leave') :  $t('requests.motif_stop_request')}} :</div>
            <div class="flex-1 px-4 py-2 m-2">{{details.advRequest.closed_request.motif}}</div>
          </div>
          <div class="inline-flex" v-if="details.advRequest.closed_request.doc_id">
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.doc_stop_request')}} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a
                :href="details.advRequest.closed_request.path"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.doc_stop_request') }}</a>
            </div>
          </div>
        </div>


    </div>
  </div>
</template>


<style scoped>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
.loader {
  margin: 0 0 2em;
  height: 100px;
  width: 80%;
  text-align: center;
  padding: 1em;
  margin: 0 auto 1em;
  display: inline-block;
  vertical-align: top;
}

/*
  Set the color of the icon
*/

.loader svg path,
.loader svg rect {
  fill: #ff6700;
}

.bg-doc {
  background-repeat: no-repeat;
  background-size: 50px 49px;
  height: 50px;
  width: 50px;
}
.px-4[data-v-6f1e2e87][data-v-6f1e2e87][data-v-6f1e2e87] {
  padding-left: 0rem;
}
</style>

<script>
import ApiService from "@/common/api.service";
import {
  REQUEST_FORM_GET,
  REQUEST_LABEL_GET,
  REQUEST_FORM_GET_DETAIL
} from "@/store/actions.type";
import { mapGetters, mapState } from "vuex";
import QForm from "@/components/Candidat/QForm.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp,
  SET_REQUEST_FORM
} from "@/store/mutations.type";
import commentRequest from "../Label/commentRequest.vue";

export default {
  name: "fromrequest",
  components: {
    "q-form": QForm,
    commentRequest: commentRequest,
    "sp-button": ButtonVue
  },

  data() {
    return {
      questions: null,
      details: null,
      content: null,
      inProgress: false,
      isSubmitted: false,
      showError: false,
      responses: [],
      responses_questions: [],
      comment_requests: [],
      hash: ''
    };
  },
  mounted() {
    this.$store.commit(SET_LabelMenuActive, 1);
    this.$store.commit(SET_ApplicationMenuActive, 0);
    //this.$store.commit(SET_HashId, this.session.startup_application.id);
    this.$store.commit(SET_LabelApp, this.$route.params.code_label);

    this.id = this.$route.params.id;
    this.code_label = this.$route.params.code_label;
    this.request_id = this.$route.params.request_id;
    this.showStartupRequestByDetail(this.code_label, this.id, this.request_id);
    if (this.$route.params.code_label) {
      this.$Progress.start();
      this.$store
        .dispatch(REQUEST_FORM_GET, {
          label: this.$route.params.code_label,
          type_id: this.$route.params.id,
          request_id: this.$route.params.request_id
        })
        .then(() => {
          this.$Progress.finish();
        });
    } else {
      if (!this.$route.params.appHash) {
        this.$Progress.start();
        this.$store
          .dispatch(REQUEST_LABEL_GET, { type_id: this.$route.params.id })
          .then(() => {
            this.$Progress.finish();
          });
      }
    }
  },
  methods: {
    onClickCommentRequest(comment) {
      var comment_candidat = {
        content: comment[0],
        created_at: new Date(),
        last_name: this.session.user_auth.last_name,
        name: this.session.user_auth.name,
        ref_id: this.details.advRequest.id,
        user_id: this.session.user_auth.id,
        document_path: comment[1]
      };
      this.comment_requests.unshift(comment_candidat);
    },
    showModal() {
      this.$modal.show("comment-request");
    },
    updateDisabled(val) {
      this.inProgress = val;
      this.isSubmitted = val;
    },
    requestFormGetDetail() {
      this.$Progress.start();
      let form = this.getForm();
      this.isSubmitted = false;
      this.$store
        .dispatch(REQUEST_FORM_GET_DETAIL, form)
        .then(data => {
          this.responses = [];
          this.isSubmitted = true;
          this.inProgress = false;
          this.showError = true;
        })
        .catch(() => {
          this.inProgress = false;
        });
      window.scrollTo(0, 0);

      this.$Progress.finish();
    },
    getForm() {
      this.inProgress = true;
      let finalResponses = [];
      Array.prototype.forEach.call(this.responses, final => {
        if (final.content != "") {
          finalResponses.push(final);
        }
      });
      let form = {
        label: this.$route.params.code_label,
        type_id: this.$route.params.id,
        request_id: this.$route.params.request_id,
        responses: finalResponses
      };
      return form;
    },
    showStartupRequestByDetail(code_label, id, request_id) {
      this.code_label = this.$route.params.code_label;
      this.id = this.$route.params.id;
      this.request_id = this.$route.params.request_id;
      this.hash = this.$route.params.appHash;
      if (this.hash) {
        ApiService.get(
          `/api/request/get-request/${id}`
        )
          .then(data => {
            this.$store.commit(SET_REQUEST_FORM, data.data.data);
            this.responses_questions = data.data.data.form.questions;
            this.details = data.data.data;
            this.comment_requests = data.data.data.advRequest.comments;
            this.candidat = data.data.data.user;
          })
          .catch(response => {
            this.$router.push({ name: "home" });
          });
      } else {
        ApiService.get(
          `/api/request/show-detail/${code_label}/${id}/${request_id}`
        )
          .then(data => {
            this.$store.commit(SET_HashId, data.data.data.project.hash_id);
            if (Object.keys(data.data.data).length === 0) {
              this.$router.push({
                path: "/avantages",
                params: {
                  app_id: this.hashId
                }
              });
            } else {
              this.responses_questions = data.data.data.form.questions;
              this.details = data.data.data;
              this.comment_requests = data.data.data.advRequest.comments;
              this.candidat = data.data.data.user;
            }
          })
          .catch(response => {
            this.$router.push({ name: "home" });
          });
      }
    }
  },

  computed: {
    ...mapGetters([
      "session",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication",
      "requestForm"
    ]),
    ...mapState({
      errors: state => state.session.errors
    }),
    getLabelCreatedAt() {
      if (this.session && this.session.startup_application && this.session.startup_application.label_created_at) {
        return this.session.startup_application.label_created_at;
      }
      return null;
    }
  },
   created () {
    this.id = this.$route.params.id;
    this.code_label = this.$route.params.code_label;
    this.request_id = this.$route.params.request_id;
    this.showStartupRequestByDetail(this.code_label, this.id, this.request_id);
    if (this.$route.params.code_label) {
      this.$Progress.start();
      this.$store
        .dispatch(REQUEST_FORM_GET, {
          label: this.$route.params.code_label,
          type_id: this.$route.params.id,
          request_id: this.$route.params.request_id
        })
        .then(data => {
          this.$Progress.finish();
        });
    } else {
      if (!this.$route.params.appHash) {
        this.$Progress.start();
        this.$store
          .dispatch(REQUEST_LABEL_GET, { type_id: this.$route.params.id })
          .then(() => {
            this.$Progress.finish();
          });
      }
    }
  }, 
};
</script>

<style scoped>
.px-4[data-v-6f1e2e87][data-v-6f1e2e87] {
  padding-left: 0rem;
}

@import "../../assets/css/style_comments.scss";
</style>


